export const SET_COURSE_SETTINGS = 'SET_COURSE_SETTINGS'
export const SET_COURSE_SETTINGS_VALUE = 'SET_COURSE_SETTINGS_VALUE'
export const SET_STATUS_COLOR = 'SET_STATUS_COLOR'
export const SET_SUBJECT = 'SET_SUBJECT'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_AGREEMENT_CONTENT = 'SET_AGREEMENT_CONTENT'
